import http from '@/components/services/http-common';

export const ROUTE = 'departments/office';

class ManagerRoleApi {
  /**
   * Lấy dữ liệu cây cơ cấu tổ chức
   */
  getTree(type = 'office') {
    return http.get(`departments/${type}/tree`).then(res => {
      if (Array.isArray(res.data)) {
        return res.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    });
  }

  /**
   * Lấy danh sách nhân viên
   */
  getEmployees(params) {
    return http.get('employees/v2', { params }).then(res => {
      if (Array.isArray(res.data)) {
        return res.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    });
  }

  /**
   * Lấy danh sách quản lý bán hàng theo tháng
   */
  getSalesManagers(month) {
    return http.get(`Departments/month-manager`, { params: { month } }).then(res => {
      if (Array.isArray(res.data)) {
        return res.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    });
  }

  /**
   * Cập nhật người quản lý bán hàng (ASM/RSM)
   */
  updateSalesManager(data) {
    return http.put(`Departments/month-manager`, data);
  }

  /**
   * Thay đổi người quản lý
   */
  updateManager(deptCode, manager, level, note, executeAt, isImmediate) {
    return http.put(`departments/manager`, null, {
      params: {
        deptCode,
        manager,
        level,
        note,
        executeAt,
        isImmediate
      }
    });
  }
}

export default new ManagerRoleApi();
